import { Button, Heading, Icon, IconButton, Input, InputGroup, InputRightElement, Select, Spinner, Stack, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { AiFillWarning } from "react-icons/ai";

import { FaArrowLeft, FaArrowRight, FaCheck, FaSearch } from "react-icons/fa";
import { RiFilterFill } from "react-icons/ri";
import { GET } from "../../../utils/ApiRequestProvider";

export default function ExceptionManagement() {
    const toast = useToast();
    const [invs, setInvs] = useState<Array<any>>([]);
    const [loading, setLoading] = useState(false);
    const [paginationQuery, setPaginationQuery] = useState({ page: 1, pageSize: 10 });
    const [pagination, setPagination] = useState({ currentPage: 0, totalPages: 0, totalRecords: 0 });

    async function FetchList() {
        setLoading(true);
        try {
            const res = await GET(`/api/internal/exceptions?page=${paginationQuery.page}&pageSize=${paginationQuery.pageSize}`);
            setInvs(res.data.documents ?? []);
            setPagination(res.data.pagination);
        } catch (err) {
            toast({
                title: 'Something Went Wrong!',
                description: 'An unexpected error occured while proceeding your request!',
                status: 'error', isClosable: false, duration: 1000, position: 'top-right'
            });
        }
        setLoading(false);
    }

    useEffect(() => {
        FetchList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationQuery]);

    return (
        <Stack w={'full'} justify={"center"} align={"center"} spacing={6}>
            <Stack
                direction={{ base: 'column', md: 'column', lg: 'column', xl: 'row' }}
                justify={'space-between'}
                boxShadow={'base'}
                rounded={'xl'}
                w={'98%'}
                p={4}
                spacing={{ base: 6, md: 6, lg: 6, xl: 0 }}
            >
                <Stack
                    align={'flex-start'}
                    justify={'start'}
                    spacing={4}
                >
                    <Stack direction={'row'}>
                        <Icon
                            as={AiFillWarning}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>Exception Management</Heading>
                            <Text fontSize={'sm'}>Here you can view all your exceptions.</Text>
                        </Stack>
                    </Stack>
                </Stack>
                <Stack
                    spacing={4}
                    justify={'end'}
                    direction={'row'}
                    align={{ lg: 'flex-start', xl: 'flex-end' }}
                >
                    <Button
                        size={'sm'}
                        leftIcon={<FaCheck />}
                    // color={'white'}
                    // bg={'primary.400'}
                    // _hover={{ bg: 'primary.400' }}
                    // _active={{ bg: 'primary.400' }}
                    >
                        Resolved
                    </Button>

                    <Button
                        size={'sm'}
                        color={'white'}
                        bg={'primary.400'}
                        _hover={{ bg: 'primary.400' }}
                        _active={{ bg: 'primary.400' }}
                    >
                        Unresolved
                    </Button>

                    <Button
                        size={'sm'}
                    // color={'white'}
                    // bg={'primary.400'}
                    // _hover={{ bg: 'primary.400' }}
                    // _active={{ bg: 'primary.400' }}
                    >
                        Recent
                    </Button>

                    <Button
                        size={'sm'}
                        leftIcon={<RiFilterFill />}
                    // color={'white'}
                    // bg={'primary.400'}
                    // _hover={{ bg: 'primary.400' }}
                    // _active={{ bg: 'primary.400' }}
                    >
                        Filter
                    </Button>
                    <Stack direction={'row'} spacing={2}>
                        <InputGroup size={'sm'}>
                            <Input placeholder='Search' />
                            <InputRightElement children={<FaSearch color={'#ababab'} />} />
                        </InputGroup>
                        <Input
                            type="date"
                            size={'sm'}
                        />
                    </Stack>
                </Stack>
            </Stack>

            <Stack boxShadow={'base'} rounded={'xl'} w={'98%'} p={4} spacing={4}>
                <TableContainer h={'sm'} overflowY={'scroll'}>
                    <Table size='sm'>
                        <Thead position={'sticky'} top={'0%'} h={'50px'} bg={'primary.400'} alignItems={'flex-start'}>
                            <Tr>
                                <Th
                                    isNumeric
                                    color={"white"}
                                >
                                    Error Log Id
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Date
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Time
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Elapsed Time
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    User ID
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    User Email
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Org ID
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Org Name
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Entity ID
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Entity Name
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Stored Procedure
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Machine
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Unique Check
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Cause
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Status
                                </Th>
                                <Th
                                    color={'white'}
                                    colSpan={2}
                                >
                                    Actions
                                </Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                invs.length > 0 ? (
                                    invs.map((inv, i) => (
                                        <Tr key={i}>
                                            <Td>{inv.logId}</Td>
                                            <Td>{inv.date}</Td>
                                            <Td>{inv.time}</Td>
                                            <Td>{inv.elapsedTime}</Td>
                                            <Td>{inv.userid}</Td>
                                            <Td>{inv.userEmail}</Td>
                                            <Td>{inv.orgId}</Td>
                                            <Td>{inv.orgName}</Td>
                                            <Td>{inv.entityId}</Td>
                                            <Td>{inv.entityName}</Td>
                                            <Td>{inv.storedProcedure}</Td>
                                            <Td>{inv.machine}</Td>
                                            <Td>{inv.uniqueCheck}</Td>
                                            <Td>{inv.cause}</Td>
                                            <Td>{inv.status}</Td>
                                            <Td colSpan={2}>
                                                <Button
                                                    w={'full'}
                                                    size={'sm'}
                                                    color={'white'}
                                                    bg={'primary.400'}
                                                    _hover={{ bg: 'primary.400' }}
                                                    _active={{ bg: 'primary.400' }}
                                                >
                                                    Details
                                                </Button>
                                            </Td>
                                        </Tr>
                                    ))
                                ) : (
                                    <Tr>
                                        <Td colSpan={17} textAlign={'center'}>
                                            {loading ? <Spinner size={'sm'} color={'primary.400'} /> : 'No Data Available'}
                                        </Td>
                                    </Tr>
                                )
                            }
                        </Tbody>
                    </Table>
                </TableContainer>
                <Stack
                    direction={'row'}
                    justify={"space-between"}
                    align={'center'}
                >
                    <Text>Showing {invs.length} of {pagination.totalRecords} results</Text>
                    <Stack direction={'row'} spacing={4}>
                        <Select defaultValue={10} onChange={(e) => setPaginationQuery({ page: 1, pageSize: parseInt(e.target.value) })}>
                            <option value={5}>5 Per Page</option>
                            <option value={10}>10 Per Page</option>
                            <option value={25}>25 Per Page</option>
                            <option value={50}>50 Per Page</option>
                        </Select>
                        <Stack direction={'row'}>
                            <IconButton
                                aria-label="Previous"
                                icon={<FaArrowLeft />}
                                rounded={'full'}
                                disabled={pagination.currentPage <= 1}
                                onClick={() => setPaginationQuery({ ...paginationQuery, page: pagination.currentPage - 1 })}
                            />
                            <IconButton
                                aria-label="Next"
                                icon={<FaArrowRight />}
                                rounded={'full'}
                                disabled={pagination.currentPage >= pagination.totalPages}
                                onClick={() => setPaginationQuery({ ...paginationQuery, page: pagination.currentPage + 1 })}
                            />
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
        </Stack >
    )
}